import React from 'react'

export const Highlights = ({ description }) => (
  <div
    className="product__highLights-content"
    dangerouslySetInnerHTML={{ __html: description }}
    data-testid="pdp-highlights"
  />
)
